module.exports = __webpack_public_path__ + "static/media/research.72a1981c.svg";